<template>
    <div>
        <div class="row" v-if="empty">
            <div class="col-sm-12 text-center">
                Cart is empty.
            </div>
        </div>
        <div class="col-md-12 noPadding" v-else>
            <div class="header">
                <div class="image">Bild</div>
                <div class="title">Beschreibung</div>
                <div class="quantity">Menge</div>
                <div class="cart" v-if="!readonly">Löschen</div>
            </div>
        </div>
        <cart-row v-for="item in items" :key="item.rowId" :item="item" :value="item.qty" :stock="item.pstock" :readonly="readonly"></cart-row>
    </div>
</template>

<script>
export default {
  
    props: {
        readonly: {
            default: false
        },
        comment: {
            default: ''
        },
        instance: {
            default: 'default'
        }
    },

    data() {
            return {
                loading: false,
                loadingCart: true,
                userComment: '',
                items: {}
            }
    },

    created() {
        new Form({instance:this.instance}).post('/api/cart/content')
            .then((response) => {
                this.items = response.items;
                this.$emit('onLoad', this.items);
                this.loadingCart = false;
            });

        App.event.listen('cart.updated', (response) => {
            this.items = response.items,
            this.data = response.data;
        });
    },

    computed: {

        empty() {
            return this.initialized && Object.keys(this.items).length === 0;
        },

        totalsSpan() {
            return this.readonly ? 1 : 2;
        }
    }
}
</script>
